<template>
  <div class="stat-card">
    <div class="header">
      <span class="title">{{ $lang('问题件类型分布') }}</span>
      <div class="filters">
        <el-radio-group v-model="dateType" size="mini" @change="getData">
          <el-radio-button label="1">{{ $lang('近7日') }}</el-radio-button>
          <el-radio-button label="2">{{ $lang('近1月') }}</el-radio-button>
          <el-radio-button label="3">{{ $lang('近3月') }}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="content" v-loading="loading">
      <div class="chart" ref="chart"></div>
      <div v-if="dataList.length > 0" class="legend-list">
        <div class="legend-item" v-for="(item, index) in dataList" :key="index">
          <span class="legend-dot" :style="{ backgroundColor: item.color }"></span>
          <span class="name" :title="item.name">{{ item.name || '--' }}</span>
          <span class="percent" :title="item.percent + '%'">{{ item.percent || 0 }}%</span>
          <span class="value" :title="item.value">
            <count-to :start-val="0" :end-val="item.value" :duration="2000" separator="," />
            {{ $lang('票') }}
          </span>
        </div>
      </div>
      <div v-else class="no-data">{{ $lang('暂无数据') }}</div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { reqProblemCount } from '@/api/module/dashboard'
import CountTo from 'vue-count-to'

export default {
  name: 'ProblemDistribution',
  components: {
    CountTo,
  },
  data() {
    return {
      COLOR_LIST: ['#ff4757', '#ffa502', '#1e90ff', '#3742fa', '#2ed573', '#f78fb3', '#ff6348', '#ffa500', '#00d2d3', '#ff9ff3', '#54a0ff', '#5f27cd', '#00d84a', '#ff3838'], // 14种鲜艳亮色，无灰暗色
      chart: null,
      loading: false,
      dateType: '1',
      dataList: [],
    }
  },
  mounted() {
    this.getData()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    async getData() {
      try {
        this.loading = true
        const res = await reqProblemCount({
          dateType: this.dateType,
        })
        if (res.code === 1) {
          this.dataList = (res?.data || []).map((item, index) => ({
            name: item.problemName,
            value: item.num,
            percent: item.rate,
            color: this.COLOR_LIST[index % this.COLOR_LIST.length],
          }))
          this.initChart()
        }
      } finally {
        this.loading = false
      }
    },
    handleResize() {
      if (this.chart) this.chart.resize()
    },
    initChart() {
      const dom = this.$refs.chart
      this.chart = echarts.getInstanceByDom(dom) || echarts.init(dom)
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return `
              <div style="width: 220px;white-space: normal;">${params.name}:</div>
              <div style="font-weight: bold;">${params.value} (${params.percent}%)</div>
            `
          },
          position: 'right',
        },
        series: [
          {
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: { show: false },
            labelLine: { show: false },
            data: this.dataList.map((item) => ({
              value: item.value,
              name: item.name,
              itemStyle: { color: item.color },
            })),
          },
        ],
      }
      this.chart.setOption(option)
    },
  },
}
</script>

<style lang="scss" scoped>
.stat-card {
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  height: 100%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      font-weight: bold;
      color: #303133;
      max-width: 140px;
    }
    .filters {
      .filter-tag {
        font-size: 12px;
        padding: 2px 8px;
        cursor: pointer;
        color: #909399;
        &.active {
          color: #ff4757;
          background: #ffe2e5;
          border-radius: 4px;
        }
      }
    }
  }

  .content {
    flex: 1;
    display: flex;
    align-items: center;

    .chart {
      width: 150px;
      height: 150px;
      margin-right: 20px;
    }
    ::-webkit-scrollbar {
      width: 6px; /* 垂直滚动条宽度 */
    }

    .legend-list {
      flex: 1;
      height: 148px;
      overflow: auto;
      padding-right: 8px;

      .legend-item {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        font-size: 12px;
        color: #606266;

        .legend-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 8px;
        }
        .name {
          width: 45%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 20px;
        }
        .percent {
          width: 10%;
          text-align: right;
          margin-right: 20px;
        }
        .value {
          flex: 1;
          text-align: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.no-data{
  color: #666
}
</style>
